import { GraphDisplayInfo } from '../types';
import { XAxisOption } from 'features/common/hooks/useChart/types';
import { useTranslation } from 'react-i18next';
import { PunchupFilterSelect } from 'features/common/components/Punchup/primitives/forms/pickers/PunchupFilterSelect';
import styles from './PunchupSetTimelineZoom.module.css';

export const PunchupSetTimelineZoom = ({ setDisplay, displayWindow }: GraphDisplayInfo) => {
	const { t } = useTranslation();

	const timelineOptions = [
		{ label: t('days'), value: 'days' },
		{ label: t('weeks'), value: 'weeks' },
		{ label: t('months'), value: 'months' },
	];

	return (
		<PunchupFilterSelect
			options={timelineOptions}
			value={displayWindow.xAxis}
			onChange={(v) => setDisplay({ type: 'set_timeline', payload: v as XAxisOption })}
			className={styles.zoomSelect}
		/>
	);
};
